module.exports = __webpack_public_path__ + "img/mor-read_05.d78f21e6.jpg";